import { IconFont } from '@/components/IconFont'
import { createOrganization } from '@/services/organization/organization.service'
import { selectUser } from '@/store/user/user.slice'
import { APP_NAME } from '@/utils/constants'
import { useRequest, useTitle } from 'ahooks'
import { Button, Form, Input, Radio, Row, Space, Typography } from 'antd'
import React, { memo } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import styles from './index.module.less'
const { Text, Title } = Typography

export default memo(function CreateOrganization() {
  useTitle(`${APP_NAME}-Set up your organization`)
  const [form] = Form.useForm()
  const navigate = useNavigate()
  const userInfo = useSelector(selectUser).userInfo
  const { loading, run } = useRequest(createOrganization, {
    manual: true,
    onSuccess: () => {
      navigate('/list')
    }
  })

  return (
    <div className={styles.container}>
      <Form
        className={styles.form}
        form={form}
        autoComplete='off'
        layout='vertical'
        onFinish={(values) => {
          run(values)
        }}
      >
        <div className={styles.titleContent}>
          <Title level={3}>Set up your organization</Title>
          <Text type='secondary'>Tell us about your organization</Text>
        </div>

        <Form.Item
          label='Organization account name'
          name='name'
          rules={[{ required: true, message: 'Please enter organization account name' }]}
          extra={
            <span>
              This will be the name of your account on Turnkey Designers your URL will be:
              <a href='http://app.turnkeydesigners.com/' target='_blank' rel='noreferrer'>
                http://app.turnkeydesigners.com/
              </a>
            </span>
          }
        >
          <Input size='large' type='text' />
        </Form.Item>

        <Form.Item
          label='Contact email'
          name='contactEmail'
          rules={[
            { required: true, message: 'Please enter contact email' },
            { type: 'email', message: 'Invalid email format' }
          ]}
        >
          <Input size='large' type='email' />
        </Form.Item>

        <Form.Item label='Description' name='description' rules={[]}>
          <Input.TextArea rows={3} placeholder='Add some description of the organization' />
        </Form.Item>

        <Form.Item
          label='This organization belongs to'
          name={'personal'}
          rules={[{ required: true, message: 'Required' }]}
        >
          <Radio.Group>
            <Space direction='vertical'>
              <Radio value={true}>
                <Space align={'start'}>
                  <IconFont type={'icon-company'} />
                  <Space direction='vertical'>
                    <Text>My personal account</Text>
                    <Text type='secondary'>
                      {userInfo?.fullName}({userInfo?.email})
                    </Text>
                  </Space>
                </Space>
              </Radio>
              <Radio value={false}>
                <Space align={'start'}>
                  <IconFont type={'icon-lock1'} />
                  <Space direction='vertical'>
                    <Text>A business or institution</Text>
                    <Text type='secondary'>For example:orbit,lnc,example institute,American</Text>
                    <Form.Item shouldUpdate noStyle>
                      {() => (
                        <Form.Item
                          name={'belongsTo'}
                          label='Name of business or institution this organization belongs to'
                          extra={
                            <span>
                              This business or institution — not {userInfo?.fullName} (your personal account) — will
                              control this organization account.
                            </span>
                          }
                        >
                          <Input disabled={form.getFieldValue('personal')} size='large' type='text' />
                        </Form.Item>
                      )}
                    </Form.Item>
                  </Space>
                </Space>
              </Radio>
            </Space>
          </Radio.Group>
        </Form.Item>

        <Form.Item>
          <Row justify='center'>
            <Button htmlType='submit' type='primary' size='large' loading={loading} style={{ width: '250px' }}>
              Submit
            </Button>
          </Row>
        </Form.Item>
      </Form>
    </div>
  )
})
